/**
 * Directive for creating the auto complete address fields
 */
angular.module('bookingApp')
    .directive('skAddressAutocomplete', function($http, $timeout){
        return {
            require: 'ngModel',
            scope: {
                addressProvider: '=?',
                model: '=ngModel',

                // models for the address fields
                streetModel: '=?',
                suburbModel: '=?',
                cityModel: '=?',
                postcodeModel: '=?',
                countryModel: '=?',
                token: '=?',
                account: '=?',

                // hidden fields - if hidden do not update the model
                streetHidden: '=?',
                suburbHidden: '=?',
                cityHidden: '=?',
                postcodeHidden: '=?',
                countryHidden: '=?',

                countries: '=?',
                addressShow: '=?'
            },
            link: function($scope, element, attrs, model){
                $scope.setStreetNumber = function(streetNumber){
                    if(!$scope.streetHidden){
                        if(typeof $scope.streetModel !== 'undefined'){
                            $scope.streetModel = streetNumber + ' ' + $scope.streetModel;
                        } else {
                            $scope.streetModel = streetNumber + ' ';
                        }
                    }
                };
                $scope.setStreet = function(street){
                    if (!$scope.streetHidden) {
                        if (typeof $scope.streetModel !== 'undefined') {
                            $scope.streetModel += street;
                        } else {
                            $scope.streetModel = street;
                        }
                    }
                };
                $scope.setPostal = function(subpremise, number, street){
                    if (!$scope.streetHidden) {
                        var address = '';
                        address += (!subpremise) ? '' : subpremise + '/';
                        address += (!number) ? '' : number + ' ';
                        address += (!street) ? '' : ((number) ? street : ' ' + street);
                        $scope.streetModel = address;
                    }
                };
                $scope.setCity = function(city){
                    if (!$scope.cityHidden) {
                        $scope.cityModel = city;
                    }
                };
                $scope.setPostcode = function(postcode){
                    if (!$scope.postcodeHidden) {
                        $scope.postcodeModel = postcode;
                    }
                };
                $scope.setCountry = function(ibexCountryCode){
                    if(!$scope.countryHidden){
                        $scope.countryModel = ibexCountryCode;
                    }
                };
                $scope.setSuburb = function(suburb){
                    if (!$scope.suburbHidden) {
                        $scope.suburbModel = suburb;
                    }
                };
                $scope.resetValues = function(){
                    // clear any previously selected values
                    $scope.streetModel = '';
                    $scope.suburbModel = '';
                    $scope.cityModel = '';
                    $scope.postcodeModel = '';
                    $scope.countryModel = '';
                };
                if($scope.addressProvider.toUpperCase() === 'GOOGLE') {
                    var options = {types: ['geocode']};
                    $scope.googlePlace = new google.maps.places.Autocomplete(element[0], options);

                    google.maps.event.addListener($scope.googlePlace, 'place_changed', function () {
                        var place = $scope.googlePlace.getPlace();
                        var addressComponents = place.address_components;

                        $scope.resetValues();

                        // update/refresh the view values
                        $scope.$apply(function () {
                            $scope.addressShow = true;
                            var number = null, premise = null, street = null;
                            for (var component in addressComponents) {
                                if (addressComponents.hasOwnProperty(component)) {
                                    switch (addressComponents[component].types[0]) {
                                        case "subpremise":
                                            premise = addressComponents[component]['long_name'];
                                            break;
                                        case "street_number":
                                            number = addressComponents[component]['short_name'];
                                            break;
                                        case "route":
                                            street = addressComponents[component]['long_name'];
                                            break;
                                        case "locality":
                                            $scope.setCity(addressComponents[component]['long_name']);
                                            break;
                                        case "postal_town":
                                            $scope.setCity(addressComponents[component]['long_name']);
                                            break;
                                        case "postal_code":
                                            $scope.setPostcode(addressComponents[component]['long_name']);
                                            break;
                                        case "country": // this will need to work in with the country codes
                                            var ibexCountryCode = countryMapper.getIbexCodeFromCountryCode(addressComponents[component]['short_name']);
                                            $scope.setCountry(ibexCountryCode);
                                            break;
                                        case "sublocality_level_1":
                                            $scope.setSuburb(addressComponents[component]['long_name']);
                                            break;
                                    }
                                }
                            }
                            $scope.setPostal(premise, number, street);
                        });
                    });
                }
                if ($scope.addressProvider.toUpperCase() === 'NOMINATIM') {
                    var loader = new skLoader('.sk-input-group.nzpost');

                    $timeout(function() {
                        loader = new skLoader('.sk-input-group.nzpost');
                        loader.hide();
                    }, 0);

                    var html = '<div id="nz-post-address-dropdown">' +
                        '<ul id="nz-post-addresses-list"></ul>' +
                        '</div>';
                    element.after(html);

                    $scope.getSelectedAddressParts = function(id) {
                        loader.display();
                        $http.get('https://nominatim.openstreetmap.org/lookup', {
                            params: {
                                osm_ids: 'N' + id + ',W' + id + ',R' + id,
                                addressdetails: 1,
                                format: 'json'
                            }
                        }).success(function(data, status, headers, config){
                            loader.hide();
                            var address = data[0].address
                            $scope.addressShow = true;
                            $scope.setPostal(null, address.house_number, address.road);
                            $scope.setSuburb(address.suburb);
                            $scope.setCity(address.city);
                            $scope.setPostcode(address.postcode);
                            var ibexCountryCode = countryMapper.getIbexCodeFromCountryCode(address.country_code ? address.country_code.toUpperCase() : 'NZ');
                            $scope.setCountry(ibexCountryCode);
                        }).error(function(data, status, headers, config){
                            loader.hide();
                        });
                    };

                    $scope.$watch('model', function(newVal, oldVal) {
                        loader.display();
                        $http.get('https://photon.komoot.io/api/',{
                            params: {
                                q: $scope.model,
                                lat: '41.2924',
                                lon: '174.7787',
                                layer: 'house'
                            }
                        }).success(function(data, status, headers, config){
                            loader.hide();
                            var ulist = element.find('#nz-post-address-list');
                            nominatim.displayAddresses(data.features);
                            nominatim.setClickHandler(function(addressId){
                                nominatim.hideAddressList();
                                $scope.resetValues();
                                $scope.getSelectedAddressParts(addressId);
                            });
                        }).error(function(data, status, headers, config){
                            loader.hide();
                        });
                    });
                }
                if($scope.addressProvider.toUpperCase() === 'NZPOST'){
                    var loader = new skLoader('.sk-input-group.nzpost');

                    // ensure dome has loaded before adding the loader
                    $timeout(function(){
                        loader = new skLoader('.sk-input-group.nzpost');
                        loader.hide();
                    },0);

                    // setup the dom
                    var html = '<div id="nz-post-address-dropdown">' +
                            '<ul id="nz-post-addresses-list"></ul>' +
                        '</div>';
                    element.after(html);
                    // add the input loader
                    // var loader = new skLoader('.sk-input-group.nzpost');

                    $scope.getSelectedAddressParts = function(addressId){
                        loader.display();
                        $http.get('/open-api/address/complete/' + $scope.account, {
                            params: {
                                auth: $scope.token,
                                id: addressId
                            }
                        }).success(function(data, status, headers, config){
                            loader.hide();
                            // setup the fields
                            $scope.addressShow = true;

                            $scope.setPostal(data.premiseNumber, data.streetNumber, data.streetName);
                            $scope.setSuburb(data.suburb);
                            $scope.setCity(data.city);
                            $scope.setPostcode(data.postalCode);
                            // country will always be nz for this
                            var ibexCountryCode = countryMapper.getIbexCodeFromCountryCode('NZ');
                            $scope.setCountry(ibexCountryCode);

                        }).error(function(data, status, headers, config){
                            loader.hide();
                        });
                    };

                    // add watcher on field
                    $scope.$watch('model', function(newVal, oldVal){
                        loader.display();
                        // call the server
                        $http.get('/open-api/address/suggest/'+$scope.account,{
                            params: {
                                auth: $scope.token,
                                q: $scope.model
                            }
                        }).success(function(data, status, headers, config){
                            loader.hide();
                            var ulist = element.find('#nz-post-address-list');
                            nzpost.displayAddresses(data);
                            nzpost.setClickHandler(function(addressId){
                                nzpost.hideAddressList();
                                $scope.resetValues();
                                $scope.getSelectedAddressParts(addressId);
                            });
                        }).error(function(data, status, headers, config){
                            loader.hide();
                        });
                    });
                }
            }
        };
    });